import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledCalendarHeader,
  StyledBtnRight,
  StyledBtnLeft,
  StyleMonth,
  StyleYear,
  DateWrapper
} from './style';

const CalendarHeader = ({
  onLeftClick,
  onRightClick,
  month,
  year,
  id,
  showNavigators
}) => (
  <StyledCalendarHeader id={id} className="calendar-header">
    {showNavigators && <StyledBtnLeft size="m" onClick={e => onLeftClick(e)} />}
    <DateWrapper>
      <StyleMonth>{month}</StyleMonth>
      {` `}
      <StyleYear>{year}</StyleYear>
    </DateWrapper>
    {showNavigators && (
      <StyledBtnRight size="m" onClick={e => onRightClick(e)} />
    )}
  </StyledCalendarHeader>
);

CalendarHeader.propTypes = {
  onLeftClick: PropTypes.func,
  onRightClick: PropTypes.func,
  month: PropTypes.string,
  year: PropTypes.string,
  showNavigators: PropTypes.bool,
  id: PropTypes.string
};

export default CalendarHeader;
